<section>
    <div class="sticker sticker-custom">{{average}}/{{maxRange}}</div>
</section>